import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import { type ITreatmentStep } from '@principle-theorem/principle-core/interfaces';

export type TreatmentStepRenameDialogData = Pick<ITreatmentStep, 'name'>;

@Component({
  selector: 'pr-treatment-step-rename-dialog',
  templateUrl: './treatment-step-rename-dialog.component.html',
  styleUrls: ['./treatment-step-rename-dialog.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TreatmentStepRenameDialogComponent {
  stepFormGroup = new TypedFormGroup<TreatmentStepRenameDialogData>({
    name: new TypedFormControl(''),
  });

  constructor(
    public dialogRef: DialogRef<
      TreatmentStepRenameDialogData,
      TreatmentStepRenameDialogComponent
    >,
    @Inject(DIALOG_DATA) public data: TreatmentStepRenameDialogData
  ) {
    this.stepFormGroup.setValue(data);
  }
}
